// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function PilotDragPanel(props) {
  return React.createElement("div", {
              className: "flex gap-5 items-center mt-5 border-t-2 text-nowrap flex-wrap"
            }, props.children);
}

var make = PilotDragPanel;

export {
  make ,
}
/* react Not a pure module */
